/**
 * Handle the header
 */

const MOBILE_CLASS_NAME = 'header--mobile';
const HIDDEN_CLASS_NAME = 'header__nav--hidden';
const NAV_CLASS_NAME = 'js-header-nav';
const BUTTON_CLASS_NAME = 'header__mobile-button';
const BREAKPOINT = 710;

function createButtonElement () {
	var button = document.createElement('a');
	button.href = '#';
	button.className = BUTTON_CLASS_NAME;
	button.innerHTML = 'Meny';
	return button;
}

export default class Header {

	constructor(el) {
		this.el = document.querySelector(el);
		if (!this.el) {
			throw new Error('Header element not found');
		}

		this.button = createButtonElement();
		this.button.addEventListener('click', this.handleClick.bind(this));
		this.el.appendChild(this.button);

		this.nav = this.el.querySelector('.' + NAV_CLASS_NAME);

		document.addEventListener('DOMContentReady', this.handleWindowResize.bind(this));
		window.addEventListener('resize', this.handleWindowResize.bind(this));
		this.handleWindowResize();

		this.nav.classList.remove('is-not-loaded');
	}

	shouldMenuBeMobile() {
		let width = screen.width < window.innerWidth ? screen.width : window.innerWidth;
		return width < BREAKPOINT;
	}

	setMobile() {
		this.isMobile = true;
		this.isVisible = false;
		this.el.classList.add(MOBILE_CLASS_NAME);
		this.nav.classList.add(HIDDEN_CLASS_NAME);
	}

	setDesktop() {
		this.isMobile = false;
		this.isVisible = false;
		this.el.classList.remove(MOBILE_CLASS_NAME);
		this.nav.classList.remove(HIDDEN_CLASS_NAME);
	}

	showNav() {
		this.isVisible = true;
		this.nav.classList.remove(HIDDEN_CLASS_NAME);
	}

	hideNav() {
		this.isVisible = false;
		this.nav.classList.add(HIDDEN_CLASS_NAME);
	}

	toggleNav() {
		if (this.isVisible) {
			this.hideNav();
		} else {
			this.showNav();
		}
	}

	handleClick(ev) {
		ev.preventDefault();
		this.toggleNav();
	}

	handleWindowResize() {
		if (this.shouldMenuBeMobile() && !this.isMobile) {
			this.setMobile();
		} else if (!this.shouldMenuBeMobile() && this.isMobile) {
			this.setDesktop();
		}
	}
}
